module.exports = __webpack_public_path__ + "images/bannerPT-ad664ba2ade3f75eb977424f4457f020.png";